import {
  Grid,
  FormControl,
  Box,
  Typography,
  Card,
  DialogContent,
  IconButton,
  InputAdornment,
  TextField,
  styled,
  Select,
} from "@mui/material";
import styles from "../devotee.module.scss";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import {
  CustomTextFeild,
  CustomCheckbox,
  CustomSelect,
  CustomRadioButton,
  CustomInputLabel,
  CustomRequiredInputLabel,
  CommonButton,
  ContactNumberInput,
  CustomMenuItem,
} from "../../common/StyledComponents/StyledFields";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import constants from "../../../config/constants.json";
import { object, string, ValidationError } from "yup";
import CreditCardPayment, {
  unRegisteredUserDetailsProps,
} from "./creditCardPayment";
import Check from "./check";
import { isNil } from "lodash";
import toast from "react-hot-toast";
import React from "react";
import ModeofPayment from "../../common/modeOfPayment/modeOfPayment";
import {
  apiRequest,
  authService,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import ToastError from "../../common/toast/toastError";
import apiPath from "../../../config/apiPaths.json";
import { donationPurposeProps, roleListProps } from "../../../infrastructure/GlobalContextProvider";
import InputMask from "react-input-mask"
import DevoteeModeOfPayment from "../../common/modeOfPayment/devoteeModeOfPayment";
import ErrorPopup from "../../common/ErrorPopup";
import { useSearchParams } from "react-router-dom";
import LOCALE from "../../../config/en-us.json"

interface CommonDonationProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CustomDonationTextField = styled(TextField)`

.MuiFormControl-root {
    background-color: #fff9e4;
  }
  & input {
    overflow: unset;
    padding: 14px 20px;
    height: 10px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: #fff9e4;
    min-width: 0 !important;
  }
  & input:-webkit-autofill {
    /* Styles for autofill */
    border-radius: 8px;
    height: 20px;
    box-shadow: 0 0 0 30px #fff9e4 inset !important;
  }
  & fieldset {
    border-style: unset;
  }
  // & div {
  //    background-color: #fff9e4;
  // }
  & svg {
    background-color: #fff9e4;
  }
`;

export const CustomDonationCityStateTextField = styled(CustomDonationTextField)`
  & input:hover {
    cursor: not-allowed;
  }
`;

export const CustomSelectDonation = styled(Select)`
  & svg {
    color: #f05802;
  }
  & div {
    overflow: unset;
    padding: 6px 26px 21px;
    height: 10px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: #fff9e4;
    min-width: 0 !important;
    &:focus {
      border-radius: 8px !important; // Apply the border radius when focused
    }
  }
  & input {
    padding: 14px 16px;
    height: 20px;
    border-radius: 8px;
  }
  & fieldset {
    border-style: unset;
  }
`;

export const CustomNumberDonationField = styled(InputMask)`
  background-color: #fff9e4;
  padding: 14px 14px;
  border-radius: 8px;
  height: 10px;
  border: 1px solid rgba(136, 46, 20, 0.4);
  & input {
    border: none !important;
    padding: 5px;
  }

  :hover {
    border: 1px solid rgba(136, 46, 20, 0.4);
  }
  :focus {
    outline: none;
  }
`;



interface ErrorMessageTypes {
  name: string;
  lastName: string;
  date: string;
  donationType: string;
  email: string;
  phoneNumber: string;
  amount: string;
  password: string;
  city: string;
  state: string;
  zipcode: string;
}

interface ErrorMessageUnregTypes {
  name: string;
  lastName: string;
  donationType: string;
  email: string;
  phoneNumber: string;
  amount: string;
  city: string;
  state: string;
  zipcode: string;
  address: string;
  description: string;
}

const CommonDonations = (props: CommonDonationProps): JSX.Element => {
  const [searchParam] = useSearchParams();
  const donationID = searchParam.get("donationID")

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isMailReceiptSelected, setIsMailReceiptSelected] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const [isRegistered, setIsRegistered] = useState(false);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [donationPurposeItems, setDonationPurposeItems] = useState<
    donationPurposeProps[]
  >([]);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    name: "",
    lastName: "",
    date: "",
    donationType: "",
    email: "",
    phoneNumber: "",
    amount: "",
    password: "",
    city: "",
    state: "",
    zipcode: "",
  });

  const [errorLoginMessage, setErrorLoginMessage] = useState({
    name: "",
    password: "",
  });

  const [errorMessageUnreg, setErrorMessageUnreg] =
    useState<ErrorMessageUnregTypes>({
      name: "",
      lastName: "",
      donationType: "",
      email: "",
      phoneNumber: "",
      amount: "",
      city: "",
      state: "",
      zipcode: "",
      address: "",
      description: "",
    });

  const [formData, setFormData] = useState({
    name: "",
    password: "",
  });

  const [unregFormData, setUnregFormData] = useState({
    name: "",
    lastName: "",
    donationType: "",
    email: "",
    phoneNumber: "",
    address: "",
    amount: "",
    city: "",
    state: "",
    zipcode: "",
    description: "",
  });

  const [disableUsername, setDisableUsername] = useState<boolean>(false);
  const [continueDisable, setcontinueDisable] = useState<boolean>(true);
  const [amount, setAmount] = React.useState("");
  const [accountDescription, setaccountDescription] = useState<string>("");

  const getUserDetails = () => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.getDevoteeDetails}/${formData.name.toUpperCase()}`,
      includeToken: true,
    })
      .then((res) => {
        const userFromApi = res.data;
        setUnregFormData({
          ...unregFormData,
          name: userFromApi.firstname,
          lastName: userFromApi.lastname,
          email: userFromApi.email,
          // phoneNumber: userFromApi.phoneWork,
          phoneNumber: userFromApi.phoneWork?.startsWith("1") ? "1"+userFromApi.phoneWork : userFromApi.phoneWork,
          city: userFromApi.city,
          state: userFromApi.state,
          zipcode: userFromApi.zipcode,
        });
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const getUserDefaultRole = () => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.userRolesInfo}`,
      includeToken: true,
      params: {
        username: formData.name.toUpperCase(),
      },
    })
      .then((res) => {
        sessionStorage.setItem("name", res.data.fullName);
        sessionStorage.setItem("firstAndLastName", res.data.firstAndLastName);
        // Combine active and inActive lists into a single string with comma separation
        const rolesJsonString = JSON.stringify(res.data.roles);
        sessionStorage.setItem("user-roles", rolesJsonString);

        const defaultRoleObj = res.data.roles.find(
          (role: roleListProps) => role.roleName === res.data.defaultRole
        );
        // Store the default role ID
        if (defaultRoleObj) {
          sessionStorage.setItem(
            "userRoleId",
            defaultRoleObj.roleId.toString()
          );
        }
        sessionStorage.setItem("selectedRole", res.data.defaultRole);
        getUserDetails();
      })
      .catch((err) => {
        console.log(err);
        sessionStorage.clear();
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const handleSubmit = (e: any): void => {
    e.preventDefault();
    let usernameError = "";
    let passwordError = "";

    if (!formData.name) {
      usernameError = "Username is required";
    }
    if (!formData.password) {
      passwordError = "Password is required";
    }

    setErrorLoginMessage({
      name: usernameError,
      password: passwordError,
    });

    if (!usernameError && !passwordError) {
      const userLoginDetails: any = {
        username: formData.name,
        password: formData.password,
      };
      var formBody: any = [];
      for (var property in userLoginDetails) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(userLoginDetails[property]);
        formBody.push(encodedKey + "=" + encodedValue);
      }

      formBody = formBody.join("&");

      apiRequest({
        method: "POST",
        endpoint: apiPath.loginPath,
        body: formBody,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
        .then((res: any) => {
          setDisableUsername(false);
          sessionStorage.clear();
          sessionStorage.setItem("username", formData.name);
          sessionStorage.setItem("user-token", res.data.accessToken);

          getUserDefaultRole();
          setFormData({
            name: "",
            password: "",
          });
        })
        .catch((err: any) => {
          console.log(err);
          setDisableUsername(false);
          toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
            duration: constants.TOAST_POPUP_DURATION,
          });
        });
    }
  };

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.purposeOfDonations,
      // includeToken: true,
    })
      .then((res) => {
        setDonationPurposeItems(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  }, []);

  useEffect(() => {
    if (!isNil(donationID) && donationPurposeItems?.length > 0) {
      let selectedAccountDescription = null;

      const selectedItem = donationPurposeItems.find(
        (item) => item.accountNumber === donationID
      );

      // If the item is found, extract the accountNumber
      if (selectedItem) {
        selectedAccountDescription = selectedItem.accountDescription;
        setaccountDescription(selectedAccountDescription);
        setUnregFormData({
          ...unregFormData,
          donationType: donationID,
        });
        setErrorMessageUnreg({ ...errorMessageUnreg, donationType: "" });
      }
    }
  }, [donationID, donationPurposeItems]);

  const handleFieldChange = (field: string, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleUnregFieldChange = (field: string, value: any) => {
    setButtonDisable(true);
    let selectedAccountNumber = null;
    let selectedAccountDescription = null;

    // Find the selected item in donationPurposeItems
    const selectedItem = donationPurposeItems.find(
      (item) => item.accountNumber === value
    );

    // If the item is found, extract the accountNumber
    if (selectedItem) {
      selectedAccountNumber = selectedItem.accountNumber;
      selectedAccountDescription = selectedItem.accountDescription;
      setaccountDescription(selectedAccountDescription);

      // Store accountNumber in sessionStorag
    }

    // Update the form data and amount state
    setUnregFormData({
      ...unregFormData,
      [field]: value,
    });

    setAmount(unregFormData.amount);
  };

  const handleKeyDownuser = (e: any, fieldName: string) => {
    if (!/[0-9a-zA-Z_]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleSave = async (): Promise<void> => {
    const errors: ErrorMessageUnregTypes = {
      name: "",
      lastName: "",
      donationType: "",
      email: "",
      phoneNumber: "",
      amount: "",
      city: "",
      state: "",
      zipcode: "",
      address: "",
      description: "",
    };

    try {
      await validationSchemaUnreg.validate(unregFormData, {
        abortEarly: false,
      });
      if (errorMessageUnreg.zipcode !== "") {
        setErrorMessageUnreg({
          ...errorMessageUnreg,
          zipcode: "Please enter valid zipcode"
        })
      } else {
        setSelectedPaymentMode("credit card");
        setErrorMessageUnreg(errors);
        setButtonDisable(true);
        const itemsList = [
          {
            donationpurposeid: unregFormData.donationType,
            amount: unregFormData.amount,
            accountDescription: accountDescription,
          },
        ];
        sessionStorage.setItem("cartItems", JSON.stringify(itemsList));
      }
    } catch (error: any) {
      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageUnregTypes] = e.message;
          }
        });
      }
      setErrorMessageUnreg(errors);
    }
  };

  const zipCodeApi = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cityAndStateApi,
      params: {
        zip: unregFormData.zipcode,
      },
    })
      .then((res) => {
        setcontinueDisable(false);
        setErrorMessageUnreg({
          ...errorMessageUnreg,
          zipcode: "",
          city: "",
          state: "",
        });
        setUnregFormData({
          ...unregFormData,
          state: res.data.stateName,
          city: res.data.city,
        });
      })
      .catch((err) => {
        setcontinueDisable(true);
        console.log(err);
        setErrorMessageUnreg({
          ...errorMessageUnreg,
          zipcode: catchErrorMessageHandler(err),
          // zipcode: !isNil(err.response.data)
          //   ? err.errorMessage
          //   : err.response.data,
        });
        setUnregFormData({
          ...unregFormData,
          state: "",
          city: "",
        });
      });
  };

  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const validationSchemaUnreg = object().shape({
    name: !isRegistered ?  string().required("First Name is required") : string(),
    lastName: !isRegistered ? string().required("Last Name is required") : string(),
    email: !isRegistered?  string()
      .required("Email is required")
      .matches(emailRegex, "Please enter valid email address")
      .min(6, "Email must be at least 6 characters")
      .max(64, "Email cannot exceed 64 characters") : string(),
      phoneNumber: !isRegistered ? string().required("Phone Number is required") : string(),
    donationType: string().required("Please select the purpose of donation"),
    amount: string().required("Amount is required"),
    zipcode:string().required("Zipcode is required"),
  });
  
  
  

  const DonationTypeDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelectDonation
          sx={{ borderRadius: "8px" }}
          id="donationPurpose"
          placeholder="Select Donation Type"
          value={unregFormData.donationType}
          onChange={(e) => {
            setErrorMessageUnreg({ ...errorMessageUnreg, donationType: "" });
            handleUnregFieldChange("donationType", e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessageUnreg.donationType
              ? styles.errorTextField
              : styles.textField
          }
        >
          {donationPurposeItems.map((item: any, index: number) => (
            <CustomMenuItem key={index} value={item.accountNumber}>
              {item.accountDescription}
            </CustomMenuItem>
          ))}
        </CustomSelectDonation>
        {errorMessageUnreg.donationType ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessageUnreg.donationType}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const handleRegisteredChange = (checked: boolean) => {
    setErrorMessageUnreg({
      name: "",
      lastName: "",
      donationType: "",
      email: "",
      phoneNumber: "",
      amount: "",
      city: "",
      state: "",
      zipcode: "",
      address: "",
      description: "",
    });
    setIsRegistered(checked);
  };
  const handleClick = () => {
    setSelectedPaymentMode("credit card");
    setAmount(unregFormData.amount);
  };

  const paymentClick = () => {
    if (selectedPaymentMode === "credit card") {
      if (authService.isAuthenticated()) {
        navigate("/creditPayment");
      } else {
        setSelectedPaymentMode("credit card");
      }
    }
  };

  const validateEmail = () => {
    const { email } = unregFormData;

    if (email.length < 6) {
      setErrorMessageUnreg({
        ...errorMessageUnreg,
        email: "Email must be at least 6 characters long.",
      });
    } else if (email.length >= 64) {
      setErrorMessageUnreg({
        ...errorMessageUnreg,
        email: "Email must be less than 64 characters long.",
      });
    } else if (!email.includes("@")) {
      setErrorMessageUnreg({
        ...errorMessageUnreg,
        email: "Please Enter Valid Email",
      });
    } else {
      setErrorMessageUnreg({ ...errorMessageUnreg, email: "" });
    }
  };

  const comonFields = () => {
    return (
      <Grid
        container
        spacing={1}
        sx={{ padding: "10px 25px", gap: "8px" }}
        className={styles.detailsContainer}
      >
        <Grid container spacing={2}>
          <Grid xs={12} sm={4} item className={styles.singleFeild}>
            {CustomRequiredInputLabel("First Name", true)}
            <CustomDonationTextField
              id="firstName"
              fullWidth
              required
              InputProps={{
                readOnly: isRegistered,
              }}
              placeholder="Enter Firstname"
              value={unregFormData.name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setErrorMessageUnreg({ ...errorMessageUnreg, name: "" });
                const inputValue = e.target.value;

                // Limit input to 50 characters
                if (inputValue.length <= 50) {
                  // Validate input to allow only alphabets
                  if (/^[a-zA-Z]*$/.test(inputValue) || inputValue === "") {
                    handleUnregFieldChange("name", inputValue);
                  } else {
                    // Show an error message for invalid input
                    setErrorMessageUnreg({
                      ...errorMessageUnreg,
                      name: "Only alphabets are allowed.",
                    });
                  }
                } else {
                  // Show an error message for exceeding the character limit
                  setErrorMessageUnreg({
                    ...errorMessageUnreg,
                    name: "Maximum allowed characters: 50",
                  });
                }
              }}
              className={
                errorMessageUnreg.name
                  ? styles.errorTextField
                  : styles.textField
              }
            />
            {errorMessageUnreg.name ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageUnreg.name}
              </Typography>
            ) : (
              ""
            )}
          </Grid>

          <Grid xs={12} sm={4} item className={styles.singleFeild}>
            {CustomRequiredInputLabel("Last Name", true)}
            <CustomDonationTextField
              id="lastName"
              fullWidth
              required
              placeholder="Enter Lastname"
              InputProps={{
                readOnly: isRegistered,
              }}
              value={unregFormData.lastName}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setErrorMessageUnreg({ ...errorMessageUnreg, lastName: "" });
                const inputValue = e.target.value;

                // Limit input to 50 characters
                if (inputValue.length <= 50) {
                  // Validate input to allow only alphabets
                  if (/^[a-zA-Z]*$/.test(inputValue) || inputValue === "") {
                    handleUnregFieldChange("lastName", inputValue);
                  } else {
                    // Show an error message for invalid input
                    setErrorMessageUnreg({
                      ...errorMessageUnreg,
                      lastName: "Only alphabets are allowed.",
                    });
                  }
                } else {
                  // Show an error message for exceeding the character limit
                  setErrorMessageUnreg({
                    ...errorMessageUnreg,
                    lastName: "Maximum allowed characters: 50",
                  });
                }
              }}
              className={
                errorMessageUnreg.lastName
                  ? styles.errorTextField
                  : styles.textField
              }
            />
            {errorMessageUnreg.lastName ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageUnreg.lastName}
              </Typography>
            ) : (
              ""
            )}
          </Grid>

          <Grid xs={12} sm={4} item className={styles.singleFeild}>
            {CustomRequiredInputLabel("Phone No", true)}
            <CustomDonationTextField
              // sx={{ width: "" }}
              // mask="9999999999"
              // maskChar="_"
              id="phoneNumber"
              type="tel"
              required
              InputProps={{
                readOnly: isRegistered,
              }}
              value={unregFormData.phoneNumber}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setErrorMessageUnreg({ ...errorMessageUnreg, phoneNumber: "" });
                handleUnregFieldChange("phoneNumber", e.target.value);
                // validatePhoneNumber(e.target.value);
              }}
              className={
                errorMessageUnreg.phoneNumber
                  ? styles.errorTextField
                  : styles.textField
              }
            />
            {errorMessageUnreg.phoneNumber ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageUnreg.phoneNumber}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={12} sm={4} item className={styles.singleFeild}>
            {CustomRequiredInputLabel("Email", true)}
            <CustomDonationTextField
              fullWidth
              id="email"
              required
              placeholder="Enter Email"
              InputProps={{
                readOnly: isRegistered,
              }}
              value={unregFormData.email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 100) {
                  setErrorMessageUnreg({ ...errorMessageUnreg, email: "" });
                  handleUnregFieldChange("email", inputValue);
                } else {
                  setErrorMessageUnreg({
                    ...errorMessageUnreg,
                    email: "Maximum 100 characters allowed",
                  });
                }
              }}
              onBlur={validateEmail}
              className={
                errorMessageUnreg.email
                  ? styles.errorTextField
                  : styles.textField
              }
            />
            {errorMessageUnreg.email && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageUnreg.email}
              </Typography>
            )}
          </Grid>
          {!isRegistered ? (
            <Grid xs={12} sm={8} item className={styles.singleFeild}>
              {CustomRequiredInputLabel("Address", false)}
              <CustomDonationTextField
                id="address"
                fullWidth
                required
                InputProps={{
                  readOnly: isRegistered,
                }}
                placeholder="Enter Address"
                value={unregFormData.address}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const inputValue = e.target.value;
                  if (inputValue.length <= 100) {
                    setErrorMessageUnreg({ ...errorMessageUnreg, address: "" });
                    handleUnregFieldChange("address", inputValue);
                  } else {
                    setErrorMessageUnreg({
                      ...errorMessageUnreg,
                      address: "Maximum 100 characters allowed",
                    });
                  }
                }}
                className={
                  errorMessageUnreg.address
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {errorMessageUnreg.address && (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessageUnreg.address}
                </Typography>
              )}
            </Grid>
          ) : (
            " "
          )}
        </Grid>
        <Grid container spacing={2}>
          <Grid xs={12} sm={4} item className={styles.singleFeild}>
            {CustomRequiredInputLabel("Zip Code", true)}
            <CustomDonationTextField
              id="zipcode"
              fullWidth
              required
              placeholder="Enter Zipcode"
              value={unregFormData.zipcode}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const inputValue = e.target.value;
                // Only allow numbers
                const sanitizedInput = inputValue
                  .replace(/[^0-9]/g, "")
                  .slice(0, 10);
                setErrorMessageUnreg({ ...errorMessageUnreg, zipcode: "" });
                handleUnregFieldChange("zipcode", sanitizedInput);
              }}
              onBlur={zipCodeApi}
              className={
                errorMessageUnreg.zipcode
                  ? styles.errorTextField
                  : styles.textField
              }
            />
            {errorMessageUnreg.zipcode ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageUnreg.zipcode}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item className={styles.singleFeild}>
            {CustomRequiredInputLabel("City", true)}
            <CustomDonationCityStateTextField
              id="city"
              fullWidth
              required
              value={unregFormData.city}
              InputProps={{
                readOnly: true,
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setErrorMessageUnreg({ ...errorMessageUnreg, city: "" });
                handleUnregFieldChange("city", e.target.value);
              }}
              className={
                errorMessageUnreg.city
                  ? styles.errorTextField
                  : styles.textField
              }
            />
            {errorMessageUnreg.city ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageUnreg.city}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} sm={4} item className={styles.singleFeild}>
            {CustomRequiredInputLabel("State", true)}
            <CustomDonationCityStateTextField
              id="state"
              fullWidth
              required
              value={unregFormData.state}
              InputProps={{
                readOnly: true,
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setErrorMessageUnreg({ ...errorMessageUnreg, state: "" });
                handleUnregFieldChange("state", e.target.value);
              }}
              className={
                errorMessageUnreg.state
                  ? styles.errorTextField
                  : styles.textField
              }
            />
            {errorMessageUnreg.state ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageUnreg.state}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid xs={12} sm={8} item className={styles.singleFeild}>
            {CustomRequiredInputLabel("Donation Purpose", true)}
            {DonationTypeDropdown()}
          </Grid>
          <Grid xs={12} sm={4} item className={styles.singleFeild}>
            {CustomRequiredInputLabel("Amount (in dollars)", true)}
            <CustomDonationTextField
              fullWidth
              id="amount"
              required
              placeholder="Enter Amount"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" sx={{ margin: 0 }}>
                    <AttachMoneyIcon
                      fontSize="small"
                      sx={{ zIndex: "1", position: "absolute" }}
                    />
                  </InputAdornment>
                ),
              }}
              value={unregFormData.amount}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                let inputValue = e.target.value;
                // Disallow single '0'
                if (inputValue === "0") {
                  inputValue = "";
                }
                // Allow numbers and a decimal point
                const sanitizedInput = inputValue
                  .replace(/[^0-9.]/g, "")
                  .slice(0, 10);
                setErrorMessageUnreg({ ...errorMessageUnreg, amount: "" });
                handleUnregFieldChange("amount", sanitizedInput);
              }}
              className={
                errorMessageUnreg.amount
                  ? styles.errorTextField
                  : styles.textField
              }
            />
            {errorMessageUnreg.amount ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageUnreg.amount}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      
          <Grid xs={12} sm={12} item className={styles.singleFeild}>
            <Typography style={{color:"red",background:"yellow",fontFamily:"Lato",fontStyle:"normal",fontSize:"14px"}}>{LOCALE.DONATION_AMOUNT_SUGGESTION}</Typography>
          </Grid>
       
      </Grid>
    );
  };

  const isRegisteredComponent = (): React.ReactNode => {
    return (
      <>
        <Grid
          container
          spacing={1}
          sx={{
            padding: "10px 25px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          className={styles.detailsContainer}
        >
          <Grid container spacing={2}>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel(" User Name", true)}
              <CustomDonationTextField
              id="userName"
                required
                value={formData.name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setErrorLoginMessage({ ...errorLoginMessage, name: "" });
                  handleFieldChange("name", e.target.value);
                }}
                placeholder="Enter Username"
                className={
                  errorMessage.name ? styles.errorTextField : styles.textField
                }
                onBlur={() => {
                  // Convert the username to uppercase using the current state value
                  let inputUserName = formData.name.toUpperCase();
                  handleFieldChange("name", inputUserName);
                }}
                onKeyDown={(e) => handleKeyDownuser(e, "userName")}
              />
              {errorLoginMessage.name ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorLoginMessage.name}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item className={styles.singleFeild}>
              {CustomRequiredInputLabel("Password", true)}
              <CustomDonationTextField
              id="password"
                required
                value={formData.password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setErrorLoginMessage({ ...errorLoginMessage, password: "" });
                  handleFieldChange("password", e.target.value);
                }}
                placeholder="Enter Password"
                type={showPassword ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOutlinedIcon />
                        ) : (
                          <VisibilityOffOutlinedIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                className={
                  errorMessage.password
                    ? styles.errorTextField
                    : styles.textField
                }
              />
              {errorLoginMessage.password ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorLoginMessage.password}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Box sx={{ margin: "40px 16px auto 25px" }}>
              <CommonButton onClick={handleSubmit}>Login</CommonButton>
            </Box>
          </Grid>
        </Grid>
        {comonFields()}
        <Box className={styles.ModeofPayment}>
          <DevoteeModeOfPayment
            setIsOpen={props.setIsOpen}
            setSelectedPaymentMode={setSelectedPaymentMode}
            setButtonDisable={setButtonDisable}
            donationPurpose={unregFormData.donationType}
            amount={parseFloat(unregFormData.amount)}
          />
        </Box>
        <Box sx={{ padding: "0px 10px" }}>
          {!buttonDisable ? <CommonButton
            sx={{ margin: " 16px 0" }}
            disabled={buttonDisable}
            onClick={handleSave}
          >
            Proceed
          </CommonButton> : ""}
        </Box>
        {/* {authService.isAuthenticated() && (
              <Box className={styles.registeredHeading} onClick={handleClick}>
                 <Typography className={styles.paymentheading}>Mode of Payment</Typography>
                 <Card sx={{ width: '10%' }} onClick={handleClick}>
                    <Box sx={{ margin: '10px 0px 5px 15px' }}>
                       <img src="/images/CreditCard.svg" />
                    </Box>
                 </Card>
              </Box>
           )} */}
      </>
    );
  };

  const unRegisteredComponent = (unregFormData?:any): React.ReactNode => {
    return (
      <>
        {comonFields()}
        <Grid className={styles.paymentIconsAndMailChecks}>
          <Box className={styles.ModeofPayment}>
            <DevoteeModeOfPayment
              unregFormData={unregFormData}
              setIsOpen={props.setIsOpen}
              setSelectedPaymentMode={setSelectedPaymentMode}
              // creditpaymentFunction={handleSave}
              setButtonDisable={setButtonDisable}
              donationPurpose={unregFormData.donationType}
              amount={parseFloat(unregFormData.amount)}
              buttonDisable={buttonDisable}
            />
          </Box>
          <div className={styles.ckeckBoxContainer}>
            <div className={styles.label}>
              <CustomCheckbox disabled />
              <CustomInputLabel className={styles.chckboxTitle}>
                Payment Receipt over SMS
              </CustomInputLabel>
            </div>
            <div className={styles.label}>
              <CustomCheckbox
                checked={isMailReceiptSelected}
                onChange={() =>
                  setIsMailReceiptSelected(!isMailReceiptSelected)
                }
              />
              <CustomInputLabel className={styles.chckboxTitle}>
                Payment Receipt over Mail
              </CustomInputLabel>
            </div>
          </div>
        </Grid>

        <Box sx={{ padding: "0px 10px" }}>
          {!buttonDisable ? (
            <CommonButton
              sx={{ margin: " 16px 0" }}
              disabled={buttonDisable}
              onClick={handleSave}
            >
              Proceed
            </CommonButton>
          ) : (
            ""
          )}
        </Box>
      </>
    );
  };

  return (
    <div
      style={{
        maxWidth: "759px",
        height: "calc(100% - 64px)",
        borderRadius: "16px",
        background: "#FFF",
        maxHeight: "700px",
        overflowY: "unset",
      }}
    >
      <DialogContent className={styles.CommonDonationFormContainer}>
        {selectedPaymentMode === "" && (
          <div>
            <div className={styles.radioButtons}>
              <>
                <CustomRadioButton
                id="registeredDevotee"
                  checked={isRegistered}
                  onChange={() => {
                    setUnregFormData({
                      ...unregFormData,
                      name: "",
                      lastName: "",
                      email: "",
                      phoneNumber: "",
                      amount: "",
                      city: "",
                      state: "",
                      zipcode: "",
                      address: "",
                    });
                    handleRegisteredChange(true);
                  }}
                />
                <label className={styles.label}>Registered Devotee</label>
                <CustomRadioButton
                  id="unRegistredDevotee"
                  checked={!isRegistered}
                  onChange={() => {
                    setUnregFormData({
                      ...unregFormData,
                      name: "",
                      lastName: "",
                      email: "",
                      phoneNumber: "",
                      amount: "",
                      city: "",
                      state: "",
                      zipcode: "",
                      address: "",
                    });
                    handleRegisteredChange(false);
                  }}
                />
                <label className={styles.label}>Unregistered Devotee</label>
              </>
            </div>
            <>
              {isRegistered ? isRegisteredComponent() : <></>}
              {!isRegistered ? unRegisteredComponent(unregFormData) : <></>}
            </>
          </div>
        )}
        {selectedPaymentMode === "credit card" && (
          <CreditCardPayment
            setIsOpen={props.setIsOpen}
            setSelectedPaymentMode={setSelectedPaymentMode}
            amount={unregFormData.amount}
            devoteeType={authService.isAuthenticated()}
            userDetails={isRegistered ? null : {
              firstName: unregFormData.name,
              lastName: unregFormData.lastName,
              address: unregFormData.address,
              city: unregFormData.city,
              state: unregFormData.state,
              zipcode: unregFormData.zipcode,
              country: "USA",
              email: unregFormData.email,
              amount: unregFormData.amount,
            }}
          />
        )}
        {selectedPaymentMode === "check" && (
          <Check setSelectedPaymentMode={setSelectedPaymentMode} />
        )}
      </DialogContent>
    </div>
  );
};

export default CommonDonations;
